<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For my dad, Anthony ‘Tony’ Dawson</p>
<hr class="implicit-break"/>
<div class="inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-begins-section inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/image12.jpg"/>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>The Piano Man</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content">1933 – 2009</p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>‘The Song has sadly ended but the melody lives on’</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?36ca6b18